import React, { useEffect, useState } from "react";
import "../MilestoneListAdd/Milestone.scss";
import { DataGrid, GridMoreVertIcon } from "@mui/x-data-grid";
import { HiOutlineEye } from "react-icons/hi2";
import { CiEdit } from "react-icons/ci";
import { GoTrash } from "react-icons/go";
import { RxPlus } from "react-icons/rx";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Checkbox,
  IconButton,
  MenuItem,
  Popover,
  gridClasses,
  styled,
} from "@mui/material";
import { getFileName } from "../../../utils/common";
import { HttpService } from "../../../service/HttpService";
import FullScreenLoader from "../../../components/Loader/FullScreenLoader";
import { useAuth } from "../../../context/AuthProvider";
import AddEditMilestone from "../../../components/Milestone/AddEditMilestone";
import DeleteModal from "../../../components/Model/DeleteModal";
import { toast } from "react-toastify";
import { displayDuration } from "../../../Mixin/DisplayDuration";
import { Encryption } from "../../../Mixin/EncryptDecryptId";
import { useFilter } from "../../../context/FilterProvider";
import { handleDownloadMilestoneExcel } from "../DownloadMilestone";
import { FaFileExcel } from "react-icons/fa";

const Milestone = () => {
  const navigate = useNavigate();
  const { setShowLoginPopup, showLoginPopup } = useAuth();
  const httpService = new HttpService(setShowLoginPopup);

  const [rows, setRows] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [openModel, setOpenModel] = useState(false);
  const [isAdd, setIsAdd] = useState(false);
  const [milestone_id, setMilestone_id] = useState("");
  const [openDelete, setOpenDelete] = useState(false);
  const [DeleteMilestone, setDeleteMilestone] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [dataId, setDataId] = useState();
  const [loading, setLoading] = useState(false);
  const { company_id, location_id } = useFilter();
  const [pageSize, setPageSize] = useState(15);
  const [rowCount, setRowCount] = useState("");
  const [page, setPage] = useState(0);
  const [columnName, setColumnName] = useState("");
  const [sortOrder, setsortOrder] = useState("");
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [selectedId, setSelectedId] = useState([]);
  const [allIds, setAllIds] = useState(0);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const fetchMilestone = () => {
    setLoading(true);
    httpService
      .get(
        `milestone/get_milestones?page=${
          page + 1
        }&pageSize=${pageSize}&search=${searchData}&sortBy=${columnName}&sortOrder=${sortOrder}`
      )
      .then((response) => {
        // console.log(response.data);
        setRows(response?.data?.data); // Assuming the response data is an array of rows
        // setSearchData(response?.data);
        setRowCount(response?.data?.pagination?.totalRecords);
        setTimeout(() => {
          setLoading(false);
        }, 300);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching data:", error);
      });
  };

  useEffect(() => {
    fetchMilestone();
    setAllIds(0);
    setSelectedId([]);
    setIsAllSelected(false);
  }, [
    location_id,
    company_id,
    showLoginPopup,
    page,
    pageSize,
    searchData,
    columnName,
    sortOrder,
  ]);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleOpen = () => {
    setOpenModel(true);
    setIsAdd(true);
    setMilestone_id("");
  };

  const handleClose = () => {
    setOpenModel(false);
    setIsAdd(false);
    setMilestone_id("");
    setOpenDelete(false);
    fetchMilestone();
  };

  const viewPage = (id) => {
    const urlEncodedId = Encryption(id);
    // Navigate to the encrypted URL
    navigate(`view/${urlEncodedId}`);
  };

  // const searchMilestone = (searchTerm) => {
  //   const searchTermLowerCase = searchTerm.toLowerCase();
  //   const results =
  //     rows?.length > 0 &&
  //     rows?.filter((item) => {
  //       for (let key in item) {
  //         if (
  //           typeof item[key] === "string" &&
  //           item[key].toLowerCase().includes(searchTermLowerCase)
  //         ) {
  //           return true;
  //         }
  //       }
  //       return false;
  //     });
  //   if (results) {
  //     setSearchData(results);
  //   }
  // };

  const HandleDeleteMilestone = async () => {
    if (DeleteMilestone) {
      try {
        const response = await httpService.delete(
          `${"milestone/delete_milestone"}/${DeleteMilestone}`
        );
        if (response) {
          fetchMilestone();
          navigate("/milestone");
          toast.success(response?.message, {
            position: "top-right",
          });
        } else {
          throw response;
        }
        setOpenDelete(false);
        fetchMilestone();
      } catch (error) {
        setOpenDelete(false);
        toast.error(error?.response?.data?.error, {
          position: "top-right",
        });
      }
    }
  };
  const StyledGridOverlay = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    "& .ant-empty-img-1": {
      fill: theme.palette.mode === "light" ? "#aeb8c2" : "#262626",
    },
    "& .ant-empty-img-2": {
      fill: theme.palette.mode === "light" ? "#f5f5f7" : "#595959",
    },
    "& .ant-empty-img-3": {
      fill: theme.palette.mode === "light" ? "#dce0e6" : "#434343",
    },
    "& .ant-empty-img-4": {
      fill: theme.palette.mode === "light" ? "#fff" : "#1c1c1c",
    },
    "& .ant-empty-img-5": {
      fillOpacity: theme.palette.mode === "light" ? "0.8" : "0.08",
      fill: theme.palette.mode === "light" ? "#f5f5f5" : "#fff",
    },
  }));

  function CustomNoRowsOverlay() {
    return (
      <StyledGridOverlay>
        <Box sx={{ mt: 1 }}>No Data Found</Box>
      </StyledGridOverlay>
    );
  }

  const other = {
    showCellVerticalBorder: true,
    showColumnVerticalBorder: true,
  };

  const onDownloadClick = async () => {
    try {
      await handleDownloadMilestoneExcel(setShowLoginPopup);
    } catch (error) {
      console.error("Error downloading Excel:", error);
    }
  };

  const handleHeaderCheckboxChange = (event) => {
    const isChecked = event.target.checked;
    if (isChecked) {
      const allIds = rows.map((row) => row.id); // Get all the IDs from the data
      setSelectedId(allIds); // Select all IDs
      setAllIds(allIds.length);
    } else {
      setSelectedId([]); // Deselect all
    }

    setIsAllSelected(isChecked);
  };

  const toggleId = (id) => {
    setSelectedId((prev) => {
      // Check if the ID is already selected
      if (prev.includes(id)) {
        // If selected, remove it from the list
        const updatedSelectedIds = prev.filter((item) => item !== id);

        // If removing the item results in not all items being selected, uncheck "Select All"
        if (updatedSelectedIds.length < allIds) {
          setIsAllSelected(false);
        }

        return updatedSelectedIds;
      } else {
        // If not selected, add it to the list
        const updatedSelectedIds = [...prev, id];

        // If adding the item results in all items being selected, check "Select All"
        if (updatedSelectedIds.length === allIds) {
          setIsAllSelected(true);
        }

        return updatedSelectedIds;
      }
    });
  };

  const isIdSelected = (id) => {
    return selectedId.includes(id);
  };

  const deleteSelectedMile = async () => {
    if (selectedId?.length > 0) {
      try {
        const response = await httpService.post(
          "milestone/delete_all_milestone",
          { milestone_ids: selectedId } // Send JSON as payload
        );
        if (response?.success) {
          fetchMilestone();
          toast.success(response?.message, {
            position: "top-right",
          });
        } else {
          throw response;
        }
        fetchMilestone();
        setOpenDeleteModal(false);
      } catch (error) {
        setOpenDeleteModal(false);
        toast.error(error?.response?.data?.error, {
          position: "top-right",
        });
      }
    } else {
      toast.error("Please select atleast one milestone", {
        position: "top-right",
      });
    }
  };

  return (
    <>
      {loading && <FullScreenLoader />}
      <div className="milestone">
        <div className="page-title">
          <div className="title-wrap">
            <h1>Milestones</h1>
          </div>
          <div className="button-wrap">
            <button
              type="submit"
              className="btn btn-primary"
              onClick={() => handleOpen()}
            >
              <RxPlus /> Add Milestone{" "}
            </button>
          </div>
        </div>
        <div className="table-filter-wrap d-flex justify-content-between">
          <Button
            className="btn btn-delete"
            onClick={() => {
              if (selectedId?.length > 0) {
                setOpenDeleteModal(true);
              } else {
                toast.error("Please select atleast one milestone", {
                  position: "top-right",
                });
              }
            }}
          >
            Delete
          </Button>
          <div className="d-flex flex-row">
            <Button
              variant="contained"
              color="primary"
              onClick={() => onDownloadClick()}
              startIcon={<FaFileExcel />}
              className="me-3"
            >
              Download
            </Button>
            <div className="header_search-wrap">
              <div className="header_search_bar common_content">
                <div className="input-group input_group">
                  <button className="btn search-btn search_btn">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="15"
                      viewBox="0 0 21 21"
                      fill="none"
                    >
                      <circle
                        cx="9.98856"
                        cy="9.98856"
                        r="8.98856"
                        stroke="#495057"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M16.2402 16.7071L19.7643 20.222"
                        stroke="#495057"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>
                  <input
                    type="search"
                    className="form-control form_control"
                    placeholder="Search..."
                    aria-label="Search"
                    onChange={(e) => {
                      const value = e.target.value;
                      setSearchData(value);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          style={{
            height: `${rows?.length > 0 ? "" : "200px"}`,
            width: "100%",
          }}
        >
          <DataGrid
            slots={{
              noRowsOverlay: CustomNoRowsOverlay,
            }}
            rows={
              rows?.length > 0 &&
              rows?.map((row, index) => ({
                ...row,
                id: row.id,
                sequenceNumber: index + 1,
              }))
            }
            getRowHeight={() => "auto"}
            sx={{
              [`& .${gridClasses.cell}`]: {
                py: 0.5,
              },
            }}
            columns={[
              {
                field: "action",
                headerName: "Actions",
                headerAlign: "center",
                align: "center",
                width: 100,
                disableColumnMenu: true,
                renderCell: (params) => (
                  <>
                    <div className="action_icon-weap">
                      <IconButton
                        onClick={(e) => {
                          handleMenuClick(e), setDataId(params.row.id);
                        }}
                      >
                        <GridMoreVertIcon />
                      </IconButton>
                    </div>
                    {anchorEl && dataId === params?.row?.id && (
                      <Popover
                        className="popup-menu"
                        key={dataId}
                        open={Boolean(anchorEl)}
                        anchorEl={anchorEl}
                        onClose={handleCloseMenu}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "right",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                      >
                        <MenuItem
                          onClick={() => {
                            viewPage(dataId);
                          }}
                          className="menu-list-items"
                        >
                          <div className="menu-list-items-text">View</div>
                          <HiOutlineEye style={{ cursor: "pointer" }} />
                        </MenuItem>
                        <MenuItem
                          onClick={() => {
                            // console.log("params", params.row.id);
                            setOpenModel(true);
                            setIsAdd(false);
                            setMilestone_id(dataId);
                            handleCloseMenu();
                          }}
                          className="menu-list-items"
                        >
                          <div className="menu-list-items-text">Edit</div>
                          <CiEdit style={{ cursor: "pointer" }} />
                        </MenuItem>
                        <MenuItem
                          onClick={() => {
                            setOpenDelete(true);
                            setDeleteMilestone(dataId);
                            handleCloseMenu();
                          }}
                          className="menu-list-items"
                        >
                          <div className="menu-list-items-text">Delete</div>
                          <GoTrash style={{ cursor: "pointer" }} />
                        </MenuItem>
                      </Popover>
                    )}
                  </>
                ),
                sortable: false,
              },
              {
                field: "select_All",
                headerName: "Select All",
                minWidth: 150,
                align: "center",
                sortable: false,
                disableColumnMenu: true,
                renderCell: (params) => {
                  return (
                    <Checkbox
                      value="Checked"
                      checked={
                        isAllSelected
                          ? true
                          : isIdSelected(params.row.id)
                          ? true
                          : false
                      }
                      onChange={() => toggleId(params.row.id)}
                    />
                  );
                },
                headerCheckboxSelection: true,
                renderHeader: (params) => {
                  return (
                    <>
                      <Checkbox
                        checked={isAllSelected}
                        onChange={(e) => handleHeaderCheckboxChange(e)}
                      />
                      <strong>Select All</strong>
                    </>
                  );
                },
              },
              { field: "name", headerName: "Name", width: 200 },
              {
                field: "duration",
                headerName: "Duration",
                flex: 1,
                minWidth: 200,
                sortable: true,
                renderCell: (params) => {
                  // console.log(params.row.days);
                  const duration = displayDuration(
                    params.row.days,
                    params.row.hours,
                    params.row.minutes
                  );
                  return <div>{duration}</div>;
                },
              },
              {
                field: "activities",
                headerName: "Activities",
                width: 400,
                disableColumnMenu: true,
                renderCell: (params) => {
                  const activities = params.value || []; // Set activities to an empty array if undefined
                  const activityNames = activities
                    .map((activity) => activity.activity_name || "--")
                    .join(", ");
                  return <span>{activityNames}</span>;
                },
                sortable: false,
              },

              {
                field: "attached",
                headerName: "Files",
                width: 265,
                disableColumnMenu: true,
                renderCell: (params) => {
                  const attachedFiles = Array.isArray(params.value)
                    ? params.value
                    : [];

                  // If there are no attached files, return an empty div
                  if (!attachedFiles || attachedFiles.length === 0) {
                    return <div> -- </div>;
                  }

                  return (
                    <div className="file-weap">
                      {attachedFiles.slice(0, 2).map((file, index) => (
                        <span key={index}>{getFileName(file)}</span>
                      ))}
                      {attachedFiles.length > 2 && (
                        <span className="counter-tag">
                          +{attachedFiles.length - 2}
                        </span>
                      )}
                    </div>
                  );
                },
                sortable: false,
              },
              {
                field: "company_name",
                headerName: "Company",
                flex: 1,
                minWidth: 200,
                sortable: true,
                renderCell: (params) => {
                  const company = params.value || "--"; // Use a hyphen if company is falsy
                  return <div>{company}</div>;
                },
              },
              {
                field: "location_name",
                headerName: "Location",
                flex: 1,
                minWidth: 200,
                sortable: true,
                renderCell: (params) => {
                  const location = params?.value || "--"; // Use a hyphen if location is falsy
                  return <div>{location}</div>;
                },
              },
            ]}
            initialState={{
              pagination: {
                rowCount: -1,
              },
            }}
            onSortModelChange={(e) => {
              if (e && e.length > 0) {
                setsortOrder(e[0].sort);
                setColumnName(e[0].field);
              } else {
                setsortOrder("");
                setColumnName("");
              }
            }}
            paginationMode="server"
            sortingMode="server"
            rowCount={rowCount}
            pageSizeOptions={[15, 50, 100]}
            paginationModel={{ pageSize: pageSize, page: page }}
            onPaginationModelChange={(event) => {
              setPage(event?.page);
              setPageSize(event?.pageSize);
            }}
            checkboxSelection={false}
            rowSelection={false}
            autoHeight
            {...other}
          />
        </div>
      </div>
      {openModel === true && (
        <AddEditMilestone
          open={openModel}
          isAdd={isAdd}
          milestone_id={milestone_id}
          handleClose={() => handleClose()}
          fetchMilestone={() => fetchMilestone()}
          companyId={company_id}
          locationId={location_id}
        />
      )}
      <DeleteModal
        open={openDelete}
        HandleClose={() => handleClose()}
        HandleDelete={() => {
          HandleDeleteMilestone(), setMilestone_id("");
        }}
      />
      {openDeleteModal && (
        <DeleteModal
          open={openDeleteModal}
          HandleClose={() => setOpenDeleteModal(false)}
          HandleDelete={() => {
            deleteSelectedMile();
          }}
        />
      )}
    </>
  );
};

export default Milestone;
